import AccommodationTypeIcon from "@components/icons/AccommodationTypeIcon";
import LocationIcon from "@components/icons/LocationIcon";
import { JSON_SCHEMAS } from "@components/utils/constants";
import styledParser from "@libs/parser/styled-parser";
import JsonLdSchema from "@libs/schema/JsonLdSchema";
import Image from "next/legacy/image";
import Link from "next/link";
import { useMemo } from "react";
interface IAccommodationPageTopSection {
  data: any;
  region: any;
}

const AccommodationPageTopSection = ({
  data,
  region,
}: IAccommodationPageTopSection): JSX.Element => {
  const locationLink = useMemo(() => {
    return data.locations.length > 0 ? (
      <Link href={`/${data.locations[0].SEO.Slug}`}>
        {`${data.locations[0].Title}${
          region[0] ? `, ${region[0].Region_name}` : ""
        }`}
      </Link>
    ) : null;
  }, [data, region]);

  return (
    <>
      <JsonLdSchema
        data={{
          breadcrumbObjects: undefined,
          schema: undefined,
          content: data,
        }}
        type={JSON_SCHEMAS.HOTEL}
      />
      <div className="mb-3 flex items-center justify-between px-5 desktop:mx-0 desktop:mb-9">
        <div className="flex items-center">
          <div>
            <div className="h-[1.5rem] w-[1rem] stroke-darkgray">
              <LocationIcon />
            </div>
          </div>
          <div className="ml-[0.175rem] text-p14 font-semibold text-lightblue underline decoration-blue-60 underline-offset-4 hover:decoration-lightblue">
            {locationLink}
          </div>
        </div>
        <div></div>
        <div className="flex">
          <div className="mr-2">
            <AccommodationTypeIcon />
          </div>
          <div className="text-p13 font-medium text-darkgray">
            {data.Property_Category}
          </div>
        </div>

        <div className="hidden items-center desktop:block desktop:flex">
          <span className="align-bottom text-p13 font-medium text-darkgray">
            From
          </span>
          <span className="text-h6 font-semibold text-lightblue">
            &nbsp;${data.Rate.toLocaleString("en-US")}&nbsp;
          </span>
          <span className="align-bottom text-p13 font-medium text-darkgray">
            / night
          </span>
        </div>
      </div>

      <div className="block flex items-center px-5 desktop:hidden desktop:max-w-[750px]">
        <span className="text-p13 font-medium text-darkgray">From</span>
        <span className="text-h6 font-semibold text-lightblue">
          &nbsp;${data.Rate.toLocaleString("en-US")}&nbsp;
        </span>
        <span className="text-p13 font-medium text-darkgray">/ night</span>
      </div>

      {/* Overview */}
      <div className="mb-12 w-full px-5 text-p text-darkgray desktop:px-0">
        {styledParser(data.Overview)}
      </div>

      {/* Amenities */}
      <div className="mb-12 w-full px-5 desktop:mb-[2.5rem] desktop:px-0">
        <div className="mb-2 text-h5 font-semibold desktop:mb-3">Amenities</div>
        <ul className="flex flex-row  flex-wrap gap-y-3 gap-x-6 desktop:gap-y-[0.625rem]">
          {data.facilities_amenities.map(
            (facility: {
              id: number;
              Icon: {
                url: string;
              };
              Title: string;
            }) => (
              <li
                key={facility.id}
                className="flex items-center desktop:w-[31%]"
              >
                <div className="mr-2">
                  {facility?.Icon?.url ? (
                    <Image
                      src={facility.Icon.url}
                      width="24"
                      height="24"
                      layout="fixed"
                      alt={facility.Title}
                    />
                  ) : null}
                </div>
                <div>{facility.Title}</div>
              </li>
            )
          )}
        </ul>
      </div>
    </>
  );
};

export default AccommodationPageTopSection;
